module.exports = "\r\np-progressspinner {\r\n\tmargin-left: 28px !important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/utility/loader/loader.component.css
// module id = ./src/app/components/utility/loader/loader.component.css
// module chunks = main